import { render, staticRenderFns } from "./InvoiceColumns.vue?vue&type=template&id=1c7f1629&scoped=true"
import script from "./InvoiceColumns.vue?vue&type=script&lang=js"
export * from "./InvoiceColumns.vue?vue&type=script&lang=js"
import style0 from "./InvoiceColumns.vue?vue&type=style&index=0&id=1c7f1629&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7f1629",
  null
  
)

export default component.exports